<div class="main-wrapper">
  <ng-container *ngIf="!hideLayout">
  <app-header [isHome]="isHome" />
</ng-container>

<div [ngClass]="{'inner-page': !isHome}">
  <router-outlet />
</div>

<ng-container *ngIf="!hideLayout">
  <lib-footer />
</ng-container>
</div>
